import { Box, Typography } from '@mui/material';
import { Message } from '../types/messages.types';
import { MessageBubble } from './MessageBubble';
import { useCurrentUser } from '@/features/auth/hooks/useCurrentUser';

interface MessageThreadProps {
  messages: Message[];
  currentUserId: string;
}

export function MessageThread({ messages }: MessageThreadProps) {
  const { user } = useCurrentUser();
  const currentUserId = user?.id || '';

  if (messages.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
          px: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          No messages yet
        </Typography>
      </Box>
    );
  }

  return (
    <Box data-testid="message-thread">
      {messages.map(message => (
        <MessageBubble
          key={message.id}
          message={message}
          isSent={message.senderId === currentUserId}
        />
      ))}
    </Box>
  );
}
